import type { UnionAddress } from "@anaconda/core/blockchain/address"
import type { NftMiniature } from "@anaconda/core/nft/types"
import type { Atom } from "@reatom/core"
import { createScope } from "bunshi"

export interface ScopeState {
  nftAtom?: Atom<NftMiniature>
  isSelectable: (
    nft: NftMiniature,
    userWallet: UnionAddress | undefined,
  ) => { selectable: true } | { selectable: false; reason: React.ReactNode }
}

export const NftSelectionScope = createScope<ScopeState>({
  isSelectable: () => ({ selectable: true }),
})
